import { NewColor } from '@factorialco/f0-react'
import i18n from 'modules/core/lib/i18n'

const STATUS_OPTIONS = [
  'open',
  'in_progress',
  'waiting_on_requestor',
  'resolved',
  'rejected',
] as const

export const getTicketStatusOptions = () => {
  return STATUS_OPTIONS
}

export const getTicketStatusLabel = (status: string) => {
  switch (status) {
    case 'open':
      return i18n.t('ticketing.inbox.status.open')
    case 'in_progress':
      return i18n.t('ticketing.inbox.status.in_progress')
    case 'waiting_on_requestor':
      return i18n.t('ticketing.inbox.status.waiting_on_requestor')
    case 'resolved':
      return i18n.t('ticketing.inbox.status.resolved')
    case 'rejected':
      return i18n.t('ticketing.inbox.status.rejected')
    default:
      return status
  }
}

export const getTicketStatusVariant = (status: string): NewColor => {
  switch (status) {
    case 'open':
      return 'smoke'
    case 'in_progress':
      return 'malibu'
    case 'resolved':
      return 'viridian'
    case 'rejected':
      return 'lilac'
    case 'waiting_on_requestor':
      return 'yellow'
    default:
      return 'smoke'
  }
}

/**
 * Returns a semantic status variant for use in table columns (F0TagStatus).
 * Unlike getTicketStatusVariant (which returns NewColor for F0TagDot),
 * this returns Variant values expected by OneDataCollection status columns.
 */
export const getTicketStatusTableVariant = (status: string) => {
  switch (status) {
    case 'open':
      return 'neutral'
    case 'in_progress':
      return 'info'
    case 'resolved':
      return 'positive'
    case 'rejected':
      return 'critical'
    case 'waiting_on_requestor':
      return 'warning'
    default:
      return 'neutral'
  }
}
